function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 26.458333 26.458334",
    id: "svg17343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-270.54165)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19401787,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-83-0",
    width: 18.708866,
    height: 18.708866,
    x: 200.65627,
    y: 181.9474,
    transform: "rotate(44.999998)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d4ae26",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16491526,
      strokeOpacity: 1
    },
    d: "m 13.229184,272.52604 -11.2447919,11.24479 5.820833,5.82083 h 1.292429 l 0.393255,-3.43958 H 7.4083501 L 7.6729331,284.3 h 2.029852 l 0.3927399,-3.43959 H 8.2021001 l 0.264583,-1.85208 h 3.7480929 l 0.352949,-2.11667 h 1.322917 l 0.352949,2.11667 h 3.748093 l 0.264583,1.85208 H 16.362843 L 16.755582,284.3 h 2.029852 l 0.264583,1.85208 h -2.082559 l 0.393255,3.43958 h 1.292429 l 5.820833,-5.82083 z m -1.523421,8.33437 -0.294555,3.43959 h 3.635952 l -0.294556,-3.43959 z m -0.453202,5.29167 -0.295074,3.43958 h 4.543393 l -0.295074,-3.43958 z m -0.453721,5.29167 -0.08992,1.05161 2.52026,2.52026 2.520259,-2.52026 -0.08992,-1.05161 z",
    id: "rect4518-8-4-5-38-6-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTower);
export default __webpack_public_path__ + "static/media/icon-tower.18b5921cbf95630364b51396e95018ac.svg";
export { ForwardRef as ReactComponent };